import type { Message } from "./Message";
import { BASE_URLS } from "config";
import { getEnv } from "env";

const isAllowedParentOrigin = (origin: string): boolean => {
  const env = getEnv();

  if (env === "production") {
    return origin === BASE_URLS.CLIENT.production;
  }

  if (
    origin === BASE_URLS.CLIENT.staging ||
    origin === "http://localhost:3000"
  ) {
    return true;
  }

  return false;
};

const getPostMessageTargetOrigin = (): string => {
  const defaultOrigin = BASE_URLS.CLIENT[getEnv()];

  if (window.parent === window) {
    return defaultOrigin;
  }

  if (document.referrer) {
    try {
      const referrerOrigin = new URL(document.referrer).origin;
      if (isAllowedParentOrigin(referrerOrigin)) {
        return referrerOrigin;
      }
    } catch {
      // ignore invalid referrer
    }
  }

  return defaultOrigin;
};

const postMessage = (message: Message) => {
  window.parent.postMessage(message, getPostMessageTargetOrigin());
};

const logMessage = (message: Message) => {
  switch (message.type) {
    case "COMMAND:CHANGE_URL":
    case "COMMAND:LOGIN_REDIRECT":
    case "COMMAND:LOGOUT":
    case "COMMAND:MASQUERADE":
    case "EVENT:AUTH_TOKEN":
    case "EVENT:LOGIN_SUCCESS":
    case "EVENT:READY":
    case "QUERY:AUTH_TOKEN":
      console.log(
        "📬",
        message.source,
        message.type,
        "payload" in message ? message.payload : undefined
      );
      break;
    default: {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const never: never = message;
    }
  }
};

export { logMessage, postMessage };
